"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DynamicPricingInputs = exports.OrderVehiclePrice = void 0;
const legacy_enums_1 = require("@daytrip/legacy-enums");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const typeorm_1 = require("typeorm");
class OrderVehiclePrice {
    constructor(init) {
        if (init) {
            this.basicPrice = init.basicPrice;
            this.basicFee = init.basicFee;
            this.totalPrice = init.totalPrice;
            this.totalFee = init.totalFee;
            this.finalPrice = init.finalPrice;
            this.finalFee = init.finalFee;
            this.vehicleIndex = init.vehicleIndex;
            this.vehicleType = init.vehicleType;
        }
    }
    vehicleType;
    // Price based on route or flexible offer calculation
    basicPrice;
    // Fee based on route or flexible offer calculation
    basicFee;
    // Basic price + additional and toll price and multiplied by dynamic coefficients
    totalPrice;
    // Basic fee + additional and toll fee and multiplied by dynamic coefficients
    totalFee;
    // Total price with discounts applied
    finalPrice;
    // Total fee with discounts applied
    finalFee;
    // Vehicle index in the order's vehicles array
    vehicleIndex;
}
exports.OrderVehiclePrice = OrderVehiclePrice;
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsEnum)(legacy_enums_1.VehicleType),
    __metadata("design:type", Number)
], OrderVehiclePrice.prototype, "vehicleType", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsInt)()
    // Price based on route or flexible offer calculation
    ,
    __metadata("design:type", Number)
], OrderVehiclePrice.prototype, "basicPrice", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsInt)()
    // Fee based on route or flexible offer calculation
    ,
    __metadata("design:type", Number)
], OrderVehiclePrice.prototype, "basicFee", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, typeorm_1.Column)()
    // Basic price + additional and toll price and multiplied by dynamic coefficients
    ,
    __metadata("design:type", Number)
], OrderVehiclePrice.prototype, "totalPrice", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsInt)()
    // Basic fee + additional and toll fee and multiplied by dynamic coefficients
    ,
    __metadata("design:type", Number)
], OrderVehiclePrice.prototype, "totalFee", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_transformer_1.Expose)()
    // Total price with discounts applied
    ,
    __metadata("design:type", Number)
], OrderVehiclePrice.prototype, "finalPrice", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsInt)()
    // Total fee with discounts applied
    ,
    __metadata("design:type", Number)
], OrderVehiclePrice.prototype, "finalFee", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsInt)(),
    __metadata("design:type", Number)
], OrderVehiclePrice.prototype, "vehicleIndex", void 0);
class DynamicPricingInputs {
    /**
     * The value of this property is copied over from the offer for purposes of dynamic pricing to be consistent.
     * To get precise up to date values use the travelEstimates property on order.
     * Set only for orders created from managed and flexible offers.
     */
    distanceKm;
    /**
     * The value of this property is copied over from the offer for purposes of dynamic pricing to be consistent.
     * To get precise up to date values use the travelEstimates property on order.
     * Set only for orders created from managed and flexible offers.
     */
    travelTimeMinutes;
    /**
     * Copied from the flexible offer the order was created from for purposes of dynamic pricing to be consistent.
     */
    vehiclesWithOnlyOriginPricing;
    /**
     * Copied from the flexible offer the order was created from for purposes of dynamic pricing to be consistent.
     */
    vehiclesWithOnlyDestinationPricing;
    /**
     * Copied from the offer the order was created from for purposes of management.
     */
    isBlacklisted;
    /**
     * Copied from offer. Saves the sales channel to be able to recalculate prices in the future.
     */
    acquisitionChannel;
    /**
     * Copied from offer. Vehicle offer prices used when creating order for particular vehicle.
     *
     * For now used only for calculating fee coefficient for vehicle in order to properly apply
     * some of the dynamic pricing configuration, in particular elasticity experiments.
     */
    vehiclePrices;
}
exports.DynamicPricingInputs = DynamicPricingInputs;
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsInt)(),
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Number)
], DynamicPricingInputs.prototype, "distanceKm", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsInt)(),
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Number)
], DynamicPricingInputs.prototype, "travelTimeMinutes", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsArray)(),
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Array)
], DynamicPricingInputs.prototype, "vehiclesWithOnlyOriginPricing", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsArray)(),
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Array)
], DynamicPricingInputs.prototype, "vehiclesWithOnlyDestinationPricing", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Boolean)
], DynamicPricingInputs.prototype, "isBlacklisted", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsEnum)(legacy_enums_1.AcquisitionChannel),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], DynamicPricingInputs.prototype, "acquisitionChannel", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsArray)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Array)
], DynamicPricingInputs.prototype, "vehiclePrices", void 0);
//# sourceMappingURL=DynamicPricingInputs.js.map